import { ImportSagaAction, ImportSagaActions } from "../actions/importSagaActions";
import { ImportSagaState, SagaStateOptions } from "../state/importSagaState";

export const importSagaInitialState: ImportSagaState = {
  accessPointCount: 0,
  completed: null,
  correlationId: "",
  currentState: SagaStateOptions.None,
  exception: null,
  initiatedBy: "",
  isLoading: true,
  missingFields: [],
  providerNetworkId: 0,
  providerSource: null,
  started: null,
  versionId: 0,
};

export const importSagaReducer = (state: ImportSagaState, action: ImportSagaActions): ImportSagaState => {
  switch (action.type) {
    case ImportSagaAction.LoadSaga:
      return Object.freeze({
        ...state,
        isLoading: true,
      });
    case ImportSagaAction.LoadSagaSuccess:
      return Object.freeze({
        ...state,
        ...action.result,
        isLoading: false,
      });
    case ImportSagaAction.LoadSagaFailure:
      return Object.freeze({
        ...state,
        isLoading: false,
      });
    default:
      throw new Error(`Action ${JSON.stringify(action)} not handled in importSagaReducer`);
  }
};
